<template>
  <div class="shoplist">
    <div class="main no-foot">
      <div v-if="showPage">
        <img v-if="bannerUrl" :src="bannerUrl" style="width: 100%"/>
        <div class="goods-list shop" v-if="shopList.length>0">
          <ul class="goods">
            <li v-for="item in shopList">
              <div class="goods-box">
                <a>
                  <div class="goods-img" @click="toGoodsList(item.id,item.shop_name)">
                    <div class="lazy goodimg" :style="item.backgroundimg"></div>
                    <div class="mark" v-if="item.is_mark == 1" :style="{backgroundColor:item.mark_color}">{{item.mark}}</div>
                  </div>
                  <div class="goods-des" @click="toGoodsList(item.id,item.shop_name)">
                    <div class="name ellipse">{{item.shop_name}}</div>
                    <div class="comment" style="margin-top:0.03rem">
                      <CommentStars :qualityCode="item.score"></CommentStars>
                      <span>{{item.score}}</span>
                      <span style="color: #E3E3E3">|</span>
                      <span>月售 {{item.sales_append}}单</span>
                    </div>
                    <div class="flex-row-bc">
                      <div class="threshold">
                        <span style="margin-right: 0.1rem">起送 ￥{{item.threshold_amount}}</span>
                        <span style="color: #E3E3E3">|</span>
                        <div v-if="item.new_delivery_fee || item.new_delivery_fee === 0">
                          <span style="margin-right: 0">配送￥{{item.new_delivery_fee}}</span>
                          <span v-if="item.is_many_delivery == 1">起</span>
                          <span style="color: #999;text-decoration: line-through;margin-right:0">￥{{item.delivery_fee}}</span>
                        </div>
                        <div v-else>
                          <span style="margin-right: 0">配送￥{{item.delivery_fee}}</span>
                          <span v-if="item.is_many_delivery == 1">起</span>
                        </div>
                        <span v-if="item.delivery_type == 1">(商家配送)</span>
                      </div>
                      <div v-if="item.dinnerDuration">{{item.dinnerDuration}}</div>
                    </div>

                  </div>
                  <!--店铺副标题、准时达-->
                  <div class="flex-row-bc">
                    <div class="vice_title" v-if="item.vice_title">{{ item.vice_title }}</div>
                    <div class="punctual-arrive" v-if="item.zsd">{{ item.zsd }}</div>
                  </div>
                  <!--促销活动-->
                  <div class="promotion_reduce" v-if="item.promotion_reduce && item.promotion_reduce.reduce_info">
                    <span v-for="item2 in item.promotion_reduce.reduce_info" class="promotion_reduce-type border">{{item2.meet_price}}减{{item2.cut_price}}</span>
                    <!--<span class="promotion_reduce-type border">满20减7</span>-->
                    <!--<span class="promotion_reduce-type border">满30减12</span>-->
                  </div>
                  <!--店铺优惠券-->
                  <div class="promotion-and-coupon">
                    <div class="promotion" v-if="item.promotion_list && item.promotion_list.length > 0">
                      <img class="icon" v-for="pro in item.promotion_list" :src="pro.icon_url" width="100%" >
                    </div>
                    <div class="package" v-if="item.promotion_package && item.promotion_package.length > 0">
                      <span v-for="(proPackage,index5) in item.promotion_package" :key="index5">{{proPackage.package_desc}}</span>
                    </div>
                    <div class="coupon" v-if="item.coupon_list && item.coupon_list.length > 0">
                      <span class="desc" v-for="(coupon,index6) in item.coupon_list" :key="index6">{{ coupon.couponDes }}</span>
                      <span class="get">领券</span>
                    </div>
                  </div>
                  <span v-if="item.is_open == 1 && item.is_book == 0" class="shop-status">营业中</span>
                  <span v-else-if="item.is_open == 1 && item.is_book == 1" class="shop-status can-reserve">可预订</span>
                  <span class="shop-status close" v-else>已打烊</span>
                  <div class="shop-type-box">
                    <span class="shop-type border" v-if="item.is_self_take_new == 1">自提</span>
                    <span class="shop-type border" v-if="item.is_take_out == 1">外送</span>
                    <span class="shop-type eat-in border" v-if="item.is_eat_in == 1">堂食</span>
                  </div>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="no-info" v-else>
          <div class="no-goods">
            <img src="../assets/images/empty-01.png" />
            <p>这里什么都没有</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommentStars from '../components/CommentStars'
import {actions} from '../store/actions'
import AlertBox from '../components/AlertBox'
// import { MessageBox,Indicator } from 'mint-ui';
import _ from "lodash";

export default {
  name: 'index',
  components: {
    CommentStars
  },
  data () {
    return {
      shopList: [],
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      showPage: false,
      shopListType: '',
      bannerUrl: '',
      clientHeight:  document.documentElement.clientHeight,
    }
  },
  computed: {
    schoolInfo () {
      return this.$store.state.schoolInfo
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'TagPage') {
      to.meta.isUseCache = true
    }
    next()
  },
  mounted () {
    var _this = this;
    //页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0
      if (document.documentElement.scrollTop){
        marginBot = document.documentElement.scrollHeight-(document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight
      }
      // var _this = this;
      // if(!this.$route.meta.isUseCache){
      //   _this.shopList = [];
      //   _this.currentPage = 1;
      //   _this.hasMore = true;
      //   _this.showPage = false;
      //   _this.bannerUrl = '';
      //   _this.getShopList();
      // }
      if(marginBot <= 1) {
        if(_this.hasMore) {
          _this.getShopList()
        }
      }
    };
  },
  activated () {
    if(window.localStorage.getItem('category_name')){
      document.title = window.localStorage.getItem('category_name')
    }else{
      document.title = '校内订餐'
    }
    var _this = this;
    // console.log(this.$route.meta.isUseCache)
    // if(!this.$route.meta.isUseCache){
    _this.shopList = [];
    _this.currentPage = 1;
    _this.hasMore = true;
    _this.showPage = false;
    _this.bannerUrl = '';
    _this.getShopList();
    // }
  },
  methods: {
    showMoreGift: function (item) {
      item.iShowMore = !item.iShowMore;
    },
    getUserInfo () {
      var _this = this
      var token = _this.$utils.getCookie('token')
      actions.postAuthInfo(_this, {token: token}, function (data) {
        if(data.uid){
          let openid = _this.$store.state.openId
          if (data.openid && data.openid != '') {
            openid = data.openid
          }
          let obj = {
            openId: openid,
            wxUid: data.uid,
            wxLoginToken: data.login_token,
            wxToken: data.token
          }
          _this.$store.commit('changeState', obj)

          let userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex
          }
          _this.$store.commit('changeUserInfo', userInfo)
        }

        let schoolInfo = {
          schoolName: decodeURI(_this.$utils.resolveUrl().school_name),
          schoolId: _this.$utils.resolveUrl().school_id
        }
        _this.$store.commit('changeSchoolInfo', schoolInfo)
      })
    },
    getShopList: function () {
      var _this = this
      // 华农
      if (_this.$utils.resolveUrl().tag_id) {
//          var token = _this.$utils.getCookie('token')
        let obj = {
          shopListType: 'tag',
          tag_id: _this.$utils.resolveUrl().tag_id,
          category_name: decodeURI(_this.$utils.resolveUrl().category_name)
        }
        _this.$store.commit('changeState', obj)
        document.title = decodeURI(_this.$utils.resolveUrl().category_name)
        // 获取用户信息
        _this.getUserInfo()
      }
      _this.shopListType = window.localStorage.getItem('shopListType');
      _this.hasMore = false
      _this.$indicator.open();
      //  category
      if (_this.shopListType === 'tag'){
        // 先获取标签图片信息
        _this.getTagsInfo();
        var params = {
          tag_id: window.localStorage.getItem('tag_id'),
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize,
        }
        actions.getTagShopList(_this, params, function (data) {
          if(data != null && data.length > 0){
            if(data.length < _this.pageSize) {
              _this.hasMore = false
            } else {
              _this.hasMore = true
            }
            _this.currentPage = _this.currentPage +1;
            for(let shop of data){
              let obj = {
                backgroundImage: "url("+shop.pic+")"
              }
              shop.backgroundimg = obj;
              shop.iShowMore = false
              if(shop.promotion_list && shop.promotion_list.length > 0){
                shop.promotion_list = _.uniqBy(shop.promotion_list, item => item.promotion_type);
              }
              _this.shopList.push(shop);
            }
          } else {
            _this.hasMore = false
          }
          // 只有一个店铺直接跳转店铺详情
          if(_this.shopList.length === 1){
            _this.toGoodsList1(_this.shopList[0].id,_this.shopList[0].shop_name);
            return;
          }
          _this.showPage = true
          _this.$indicator.close();
          _this.$nextTick(() => {
            let goodsList = document.getElementsByClassName('goods-list');
            let item = goodsList[0].clientHeight/_this.shopList.length;
            let size = Math.round(_this.clientHeight/item);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.shopList);
            _this.$store.commit('changeRecordOtherHeight', 0);
            _this.$store.commit('changeRecordPage', 'ShopList2');
            _this.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, _this.shopList,'asa_merc_shop_listForGoods_category', 'id')
          })
        },function (data){
          _this.showPage = true
          _this.$indicator.close();
          _this.$messagebox.alert(data.body.message, '');
        })
      } else if (_this.shopListType === 'category'){
        var params = {
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize,
          category_id: window.localStorage.getItem('category_code')
        }
        // 获取当前校区商家列表
        actions.getShopList(_this, params, function (data) {
          if(data != null && data.length > 0){
            if(data.length < _this.pageSize) {
              _this.hasMore = false
            } else {
              _this.hasMore = true
            }
            _this.currentPage = _this.currentPage +1
            for(let shop of data){
              let obj = {
                backgroundImage: "url("+shop.pic+")"
              }
              shop.backgroundimg = obj
              shop.iShowMore = false;
              if(shop.promotion_list && shop.promotion_list.length > 0){
                shop.promotion_list = _.uniqBy(shop.promotion_list, item => item.promotion_type);
              }
              _this.shopList.push(shop);
            }
          } else {
            _this.hasMore = false
          }
          if(_this.shopList.length === 1){
            _this.toGoodsList1(_this.shopList[0].id,_this.shopList[0].shop_name);
            return;
          }
          _this.showPage = true;
          _this.$indicator.close();
          _this.$nextTick(() => {
            let goodsList = document.getElementsByClassName('goods-list');
            let item = goodsList[0].clientHeight/_this.shopList.length;
            let size = Math.round(_this.clientHeight/item);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.shopList);
            _this.$store.commit('changeRecordOtherHeight', 0);
            _this.$store.commit('changeRecordPage', 'ShopList');
            _this.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, _this.shopList,'asa_merc_shop_specialList', 'id')
          })
        }, function (data){
          _this.showPage = true
          _this.$indicator.close();
          _this.$messagebox.alert(data.body.message, '');
        })
      } else if (_this.shopListType === 'activity'){
        var params = {
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize
        }
        actions.getPromtionList(_this, params, function (data) {
          if(data && data.length > 0){
            if(data.length < _this.pageSize) {
              _this.hasMore = false
            } else {
              _this.hasMore = true
            }
            _this.currentPage = _this.currentPage +1
            for(let shop of data){
              let obj = {
                backgroundImage: "url("+shop.pic+")"
              }
              shop.backgroundimg = obj
              shop.iShowMore = false;
              if(shop.promotion_list && shop.promotion_list.length > 0){
                shop.promotion_list = _.uniqBy(shop.promotion_list, item => item.promotion_type);
              }
              _this.shopList.push(shop);
            }
          } else {
            _this.hasMore = false
          }
          if(_this.shopList.length === 1){
            _this.toGoodsList1(_this.shopList[0].id,_this.shopList[0].shop_name);
            return;
          }
           _this.showPage = true
          _this.$indicator.close();
        }, function (data){
          _this.showPage = true
          _this.$indicator.close();
          _this.$messagebox.alert(data.body.message, '');
        })
      }
    },
    getTagsInfo: function () {
      var _this = this
      var params = {
        school_id: _this.schoolInfo.schoolId,
        tag_id: window.localStorage.getItem('tag_id'),
        page: 1,
        pageSize: 10
      }
      actions.getTagInfo(_this, params, function (data) {
        if (data && data.pic){
          _this.bannerUrl = data.pic;
        }
      })
    },
    toGoodsList: function (id, name) {
      var _this = this
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({name:'GoodsList'})
    },
    toGoodsList1: function (id, name) {
      var _this = this
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.replace({name:'GoodsList'})
    }
  }
}
</script>
<style scoped>
  .goods-box .goods-img{
    position: relative;
  }
  .goods-box .goods-img .mark{
    position: absolute;
    padding: 0 .06rem;
    height: .3rem;
    top: 0;
    left: 0;
    line-height: .3rem;
    background-color: #FFF100;
    border-radius: .04rem;
    font-size: .22rem;
    color: #fff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// ShopList.vue?60779901